import React, { useEffect, useState } from 'react';
import CartSummary from './component/CartSummary';
import PaymentMethod from './component/PaymentMethod';
import * as Styles from './Checkout.style';
import PlaceOrder from './component/PlaceOrder';
import CartLogin from './component/CartLogin';
import { Formik } from 'formik';
import { initialValuesLogin, validationSchemaLogin } from '../util';
import { scrollToSection } from 'utils';
import CustomButton from 'components/common/custom-button';
import { useMutation } from 'react-query';
import { mutationProps } from 'utils/custom-hook';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { BASE_URL } from 'constants/env';
import { getLocalStorageValues } from 'constants/local-storage';
import { Message } from 'components/alert/Message';
import { useTranslation } from 'react-i18next';
import { CHECKOUT_BM_ID, CHECKOUT_BM } from './queries';
import { validation } from 'utils/password-validation-tooltip';
import { Base64 } from 'js-base64';
import { CustomHook } from 'utils/custom-hook';
import Header from 'pages/checkout-member/layout/header/Header';
import AppDrawer from 'pages/checkout-member/layout/app-drawer/AppDrawer';
import { navLinks } from 'utils/nav-links-util';

const Checkout = ({ isAppDrawerOpen, queryClient }) => {
  const [selected, setSelected] = useState(100);
  const [isLoad, setIsLoad] = useState(false);
  const handleClick = (index) => setSelected(index);
  const { promoBmCode } = getLocalStorageValues();
  const { t } = useTranslation();
  const { logout } = CustomHook();

  let title = selected == 100 ? 'public/checkout.string23' : 'public/checkout.string32';
  const { remember_bm_cart_login } = getLocalStorageValues();
  const { mutate: placeOrder, isLoading } = useMutation(CHECKOUT_BM);
  const cartBm = useSelector((state) => state.bmCart.bm_deploy);

  const handleOrder = async (values) => {
    let payload = { action: 'new' };
    if (remember_bm_cart_login?.userName) {
      payload['username'] = remember_bm_cart_login?.userName;
      payload['token'] = remember_bm_cart_login?.token;
    } else {
      payload['email'] = values.emailAddress;
      payload['password'] = Base64.btoa(values.password);
    }
    payload['promocode'] = promoBmCode.replace('/', '');

    await placeOrder(
      { ...payload },
      mutationProps(
        false,
        {
          isSuccess: false,
          onSuccess: async (res) => {
            try {
              const promises = [];
              for (const key in cartBm) {
                let object = cartBm[key];
                const checkoutBmIdParams = {
                  id: res.order_id,
                  action: 'append',
                  size: object.selected_size.id,
                  region: object.selected_region.id,
                  image: object.selected_image.id,
                  app: object.app,
                  backup_plan: 'plan0',
                  term: object.term,
                  promocode: promoBmCode.replace('/', ''),
                  band: '',
                  ram: '',
                  disk1: '',
                  disk2: '',
                  disk3: '',
                  disk4: '',
                  disk5: '',
                  disk6: '',
                  disk7: '',
                  disk8: '',
                  disk9: '',
                  disk10: '',
                  disk11: '',
                  disk12: '',
                  raid: '',
                  ip: '',
                  ipv6: '',
                  ipbgp: '',
                  raiddisk: '',
                };
                for (const key in object?.customServerList) {
                  const serverkey = object?.customServerList[key].key;
                  const serverId = object?.customServerList[key].id;
                  if (`${serverkey}`.includes('band')) {
                    checkoutBmIdParams.band = serverId;
                  } else if (`${serverkey}`.includes('ram')) {
                    checkoutBmIdParams.ram = serverId;
                  } else if (`${serverkey}`.includes('primarydisk')) {
                    checkoutBmIdParams.disk1 = serverId;
                  } else if (`${serverkey}`.includes('disk2')) {
                    checkoutBmIdParams.disk2 = serverId;
                  } else if (`${serverkey}`.includes('disk3')) {
                    checkoutBmIdParams.disk3 = serverId;
                  } else if (`${serverkey}`.includes('disk4')) {
                    checkoutBmIdParams.disk4 = serverId;
                  } else if (`${serverkey}`.includes('disk5')) {
                    checkoutBmIdParams.disk5 = serverId;
                  } else if (`${serverkey}`.includes('disk6')) {
                    checkoutBmIdParams.disk6 = serverId;
                  } else if (`${serverkey}`.includes('disk7')) {
                    checkoutBmIdParams.disk7 = serverId;
                  } else if (`${serverkey}`.includes('disk8')) {
                    checkoutBmIdParams.disk8 = serverId;
                  } else if (`${serverkey}`.includes('disk9')) {
                    checkoutBmIdParams.disk9 = serverId;
                  } else if (`${serverkey}`.includes('disk10')) {
                    checkoutBmIdParams.disk10 = serverId;
                  } else if (`${serverkey}`.includes('disk11')) {
                    checkoutBmIdParams.disk11 = serverId;
                  } else if (`${serverkey}`.includes('disk12')) {
                    checkoutBmIdParams.disk12 = serverId;
                  } else if (`${serverkey}`.includes('raiddisk')) {
                    checkoutBmIdParams.raiddisk = serverId;
                  } else if (`${serverkey}`.includes('raid')) {
                    checkoutBmIdParams.raid = serverId;
                  } else if (`${serverkey}`.includes('ipv6')) {
                    checkoutBmIdParams.ipv6 = serverId;
                  } else if (`${serverkey}`.includes('ip')) {
                    checkoutBmIdParams.ip = serverId;
                  } else if (`${serverkey}`.includes('bgp')) {
                    checkoutBmIdParams.ipbgp = serverId;
                  }
                }
                const promise = await CHECKOUT_BM_ID(checkoutBmIdParams);
                promises.push(promise);
              }
              await Promise.all(promises);
              let stripeApi = `/public/checkout/bm/${res.order_id}/stripe`;
              let paypalApi = `/public/checkout/bm/${res.order_id}/paypal`;
              let apiUrl = selected == 1 ? paypalApi : stripeApi;
              const { data } = await axios.get(`${BASE_URL}${apiUrl}`);
              window.location.href = data.payment_url;
            } catch (error) {
              Message.error(t(`${error.response.data.error || error.response.data.status}`), error ? t(error) : '');
            }
          },
          onError: async (err) => {
            if (
              err.response?.data?.error == 'apierror_session_timed_out' ||
              err.response?.data?.status == 'apierror_session_timed_out'
            ) {
              Message.error(t('alert25'), t('error'));
              await localStorage.removeItem('remember_bm_cart_login');
              setSelected(100);
              scrollToSection('cart-user-login');
            } else {
              Message.error(t(`${err.response?.data?.error || err.response?.data?.status}`), t('error'));
            }
          },
        },
        t,
      ),
    );
  };

  useEffect(() => {
    if (remember_bm_cart_login?.userName) {
      const currentTime = new Date().getTime();
      const timeElapsed = currentTime - remember_bm_cart_login?.login_time;
      // 600000 ms = 10 minutes
      if (timeElapsed < 600000) {
        setTimeout(() => {
          handleLogout();
        }, 600000 - timeElapsed);
      } else {
        handleLogout();
      }
    }
    setSelected(100);
  }, []);

  const handleLogout = async () => {
    setSelected(100);
    setIsLoad(true);
    await logout();
    await localStorage.removeItem('remember_bm_cart_login');
    await localStorage.removeItem('userName');
    setIsLoad(false);
  };

  const hanldeNavigation = () => history.replace(navLinks.public_checkout_bm_summary.link);

  return (
    <Styles.MemberNavigatorSC>
      <AppDrawer
        isAppDrawerOpen={isAppDrawerOpen}
        checkoutLink={navLinks.public_checkout_bm_summary.link}
        goBackLink={navLinks.public_checkout_bm.link}
        isBmCart
      />
      <Styles.PageHeaderBodyContainer>
        <Header queryClient={queryClient} noOfCartItem={cartBm} hanldeNavigation={hanldeNavigation} />
        <Formik initialValues={initialValuesLogin} validationSchema={validationSchemaLogin}>
          {(formik) => (
            <Styles.PageContainer>
              <Styles.PageContent>
                <CartSummary />
                <CartLogin isLoading={isLoad} formik={formik} handleLogout={handleLogout} />
                <PaymentMethod handleClick={handleClick} selected={selected} />
                <PlaceOrder formik={formik} selected={selected} />
              </Styles.PageContent>
              <Styles.PlaceOrderContainer>
                <CustomButton
                  disabled={
                    cartBm.length == 0 ||
                    selected == 100 ||
                    (remember_bm_cart_login?.userName != undefined
                      ? false
                      : formik.values.emailAddress == ''
                      ? true
                      : false)
                  }
                  onClick={async () => {
                    const errors = await formik.validateForm();
                    if (remember_bm_cart_login?.userName == undefined) {
                      formik.setFieldTouched('emailAddress', true);
                      if (errors.emailAddress) {
                        return scrollToSection('cart-login');
                      }
                      if (!validation(formik.values.password)) {
                        document.getElementById('password').focus();
                        return scrollToSection('cart-login');
                      }
                    }
                    handleOrder(formik.values);
                  }}
                  isLoading={isLoading}
                  title={t(title)}
                  type="submit"
                  buttonStyles={{ padding: '0.5rem 2rem' }}
                />
              </Styles.PlaceOrderContainer>
            </Styles.PageContainer>
          )}
        </Formik>
      </Styles.PageHeaderBodyContainer>
    </Styles.MemberNavigatorSC>
  );
};

export default Checkout;
